<template>
  <div id="station-page">
    <div class="nav">
      <div class="sn-nav-back">
        <a class="sn-iconbtn" href="javascript:history.go(-1);">返回</a>
        <div class="title">{{store.name}}</div>
        <div class="focus" v-if="focus.on && store.name" @click="focusStore()" :class="{act:focus.state == '1'}"></div>
      </div>
    </div>
    <!--<topNav :tit="store.name"></topNav>-->
    <template v-if="!storeCode == ''">
    <div id="store" class="clearfix">
      <div class="store-l" :class="{active: !store.img}">
        <img class="img" :src="store.img | urlProtocol" alt="">
      </div>
      <div class="store-r">
        <h2>{{store.name}}</h2>
        <span>{{store.address}}</span>
        <ul>
          <li v-for="tag in store.tags">{{tag}}</li>
        </ul>
      </div>
    </div>
    <div id="station-content">
      <div class="station-tab">
        <span @click="switchTab('service')" :class="{active: tab == 'service'}">门店服务</span>
        <span @click="switchTab('info')" :class="{active: tab == 'info'}">门店信息</span>
      </div>
      <div v-show="tab === 'service'">
        <div class="hot-act" v-show="store.activityDesc.length > 0">
          <h2>热门活动</h2>
          <div class="marquee-box" name="o2o_storefwz_activety_01"><!--{{store.activityDesc}}-->
            <div id="marquee-scroll">
              <div class="marquee-item" v-for="item in store.activityDesc">
                <span v-if="item.activityUrl" @click="subscribe(item.activityUrl)">{{item.title}}</span>
                <span v-if="!item.activityUrl" @click="goActivity(item.activityCode)">{{item.title}}</span>
              </div>
              <template v-if="store.activityDesc.length > 0">
                <div class="marquee-item" v-if="store.activityDesc[0].activityUrl">
                  <span @click="subscribe(store.activityDesc[0].activityUrl)">{{store.activityDesc[0].title}}</span>
                </div>
                <div class="marquee-item" v-if="!store.activityDesc[0].activityUrl">
                  <span @click="goActivity(store.activityDesc[0].activityCode)">{{store.activityDesc[0].title}}</span>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div id="enter-modules" v-if="iconData.length == 4">
          <ul>
            <li v-for="item in iconData" name="o2o_storefwz_service_01">
              <a :href="item.iconUrl">
                <img :src="item.iconImage | urlProtocol" alt="">
                <p>{{item.iconName}}</p>
              </a>
            </li>
          </ul>
        </div>
        <div id="tip-list" v-if="iconData.length == 4">
          <ul>
            <li v-if="iconTipData.length > 0" v-for="item in iconTipData">
              <span>{{item}}</span>
            </li>
          </ul>
        </div>
        <div class="station-slide lazyimg station-intro" id="station-slide" v-if="banner.length > 0">
          <ul>
            <li v-for="item in banner" @click="subscribe(item.linkAddress)"><img :src="item.actPic | urlProtocol" alt=""></li>
          </ul>
        </div>
        <CateNav v-if="navList.length > 0" :navList="navList" @listenChild="receiveHotNavData"/>
        <div class="hotSellList" v-if="hotList.length > 0">
          <ul>
            <li name="o2o_storefwz_goods_01" v-for="(item,index) in hotList"
                  :data-procode="item.itemCode" data-vendorcode="0000000000" class="product-proce" @click="skipInfo(item.imgUrl,item.itemName,item.salesVolume)">
            <ProductList
              :prdUrl="item.prdUrl"
              :name="item.itemName"
              :sell="item.salesVolume"
              :imgUrl="item.imgUrl"/>
          </li></ul>
        </div>
        <NoonInfo v-if="hotList.length === 0" :msg="'暂无商品数据，敬请期待'"></NoonInfo>
        <div class="sn-loading-type" v-show="hotList.length">
          <span class="sn-pull-loading hide">上拉精彩无限</span>
          <div class="sn-end-loading hide"><span>没有更多了</span></div>
        </div>
        <div class="loadmore" data-loaded=""></div>

      </div>
      <div v-show="tab === 'info'">
        <div class="store-intro" v-if="store.info">{{store.info}}</div>
        <div class="store-td tel" name="o2o_storefwz_iPhone_01">{{store.tel}} <a :href="'tel:' + store.tel">拨号</a></div>
        <div class="store-td location">{{store.address}}</div>
        <div class="work-time">
          <div class="store-td hour">营业时间：</div>
          <div class="wtime">周一至周五：{{store.workDayTime}}</div>
          <div class="wtime">周末：{{store.weekDayTime}}</div>
        </div>
        <div id="store-person" v-if="person.name">
          <div class="person-header">
            <h3>店长</h3>
          </div>
          <div class="person-info">
            <div class="person-avatar">
              <img :src="person.avatar | urlProtocol" class="img">
            </div>
            <div class="info">
              <h2>{{person.name}}<span>已服务{{person.serverNum}}次</span></h2>
              <p>{{person.info}}</p>
            </div>
            <span name="o2o_storefwz_guide_01" class="p-subscribe" @click="subscribe(person.weeklyTopGuiderUrl)">预约</span>
          </div>
        </div>
      </div>
    </div>
    <div id="station-fix-btn">
      <div class="store-tel" name="o2o_storefwz_iPhone_01">
        <a :href="'tel:' + store.tel">电话联系</a>
      </div>
      <div name="o2o_storefwz_guide_01" class="subscribe" v-if="person.name" @click="subscribe(person.weeklyTopGuiderUrl)">
        <img :src="person.avatar | urlProtocol" alt="">
        <h2>{{person.name}}</h2>
        <span>预约导购到店 ></span>
      </div>
    </div>
    </template>
    <NoonInfo v-if="storeCode == ''" :msg="'抱歉，本店已经停止营业，敬请谅解'"></NoonInfo>
    <input type="hidden" id="pagename" value="pgcate=10009;tag=100043;pgtitle=身边苏宁-服务站门店主页">
  </div>
</template>
<script>
  //导入模块
  import CONF from '@/app.conf.json'
  import Server from '../services/Entrance';
  import {Util} from '../commons/util'

  import topNav from '@/components/commons/_topNav'
  import BottomNav from '@/components/commons/bottom-nav'
  import CateNav from '@/components/commons/StationCateNav'
  import ProductList from '@/components/commons/productList'
  import NoonInfo from '@/components/commons/NoonInfo'

  import _ from 'lodash';

  export default {
    name: 'Station',
    data () {
      return {
        store: {
          img: '',
          name: '',
          address: '',
          tags: [],
          tel: '',
          activityDesc: [],
          weekDayTime: '',
          workDayTime: '',
          info: ''
        },
        focus: {
          on:false,
          state:''
        },
        person: {
          avatar: '',
          name: '',
          serverNum: '',
          info: ''
        },
        tab: 'service',
        iconData:[],
        iconTipData: [],
        banner: [],
        navList: [],
        hotList:[],
        loadable: false, //是否可下拉加载
        pageNumber: 1,
        totalPage: "",
        catelogId: '',
        storeCode: ''

      }
    },
    // 生命周期钩子
    mounted () {

      document.title="服务站";

      let _this = this;

      window.scrollTo(0,0);


      //除维修店外，其他门店可关注
      _this.$nextTick( ()=>{
        if(_this.store.name){
          _this.focus.on = true;

          $.probeAuthStatus(function () {

            Server.storepage.queryFocusStore(_this.storeCode).then(data => {

            	if(data.data.hasOwnProperty('attType')){
                _this.focus.state = data.data.attType;
              }else {
            		_this.focus.state = '0';
              }

            })
          }, function () {

            console.log('UnLogin')

          }, CONF.PASSPORT.CONFIG);
        }
      })




      setTimeout(() => {

        let $loadMore = $(".loadmore"),
            $pullLoading = $(".sn-pull-loading"),
            $snEndLoading = $(".sn-end-loading");

        Swipe(document.getElementById("station-slide"), {
          startSlide: 0,
          auto: 3000,
          continuous: true,
          disableScroll: false,
          stopPropagation: false,
          callback: function (index, elem) {
          }
        });

        // 热门活动滚动
        let idx = 0,
          scrollH = $('.marquee-box').height(),
          scrollLen = $('#marquee-scroll .marquee-item').length,
          $scroll = $('#marquee-scroll');

        $scroll.css({top: 0});
        if (scrollLen > 1) {
          setInterval(() => {

            idx++;
            if  (idx >= scrollLen) {
              idx = 1;
              $scroll.css({
                top: 0
              });
            }

            $scroll.animate({
              top: -idx * scrollH
            }, 500);
          }, 3000)
        }

        Util.saCustomInit('', '', 'http://c.m.suning.com/sidesun-station.html', '');

        $loadMore.lazyload(function (el) {

          if (!_this.loadable) {

            return;
          }

          _this.loadable = false;

          /*if (_this.pageNumber >= _this.totalPage) {

           $pullLoading.hide();
           $snEndLoading.show();
           el.attr("data-loaded", "done");
           return;
           }*/

          _this.pageNumber++;

          Server.Station.queryStationProduct(_this.storeCode, _this.catelogId, _this.pageNumber).then(data => {

            _this.loadable = true;
            if (data.length > 0) {
              let productData = [];

              _.forEach(data, item => {
                productData.push({
                  itemCode: item.itemCode,
                  prdUrl: CONF.otherPage.productPage + item.itemCode,
                  itemName: item.itemName,
                  salesVolume: item.salesVolume + '',
                  //imgUrl: Util.getImgUrl(item.itemCode, 1, 160)
                  imgUrl: $.base.getProductImg(item.itemCode, '0000000000',  200)
                })
              })
              _this.hotList = _this.hotList.concat(productData);
              
              
              setTimeout(() => {
                $('.product-proce').getProPrice({
                  //cityCode:'025',
                  isDefaultWork: true,
                })
              }, 100);
            } else {

              $pullLoading.hide();
              $snEndLoading.show();
              el.attr("data-loaded", "done");
            }
          });
          $pullLoading.show();
        });

      }, 500);
//      alert(_this.storeCode)
//      console.log($('.sn-loading-type'))

    },
    components: {
      CateNav,
      ProductList,
      NoonInfo,
      topNav
    },
    watch: {
      "catelogId": function (val, oldVal) {

        let _this = this;

        if (!val) {
          _this.hotList = [];
          return;
        }

        _this.pageNumber = 1;

        Server.Station.queryStationProduct(_this.storeCode, val, _this.pageNumber).then(data => {
          console.log(data)
          if (data.length === 0) {
            $('.sn-loading-type').hide();
            return;
          }

          let productData = [];

          _.forEach(data, item => {
            productData.push({
              itemCode: item.itemCode,
              prdUrl: CONF.otherPage.productPage + item.itemCode + '.html',
              itemName: item.itemName,
              salesVolume: item.salesVolume + '',
              //imgUrl: Util.getImgUrl(item.itemCode, 1, 160)
              imgUrl: $.base.getProductImg(item.itemCode, '0000000000',  200)
            })
          })
          _this.hotList = productData;
          _this.loadable = true;
          console.log('hotList',_this.hotList)
          setTimeout(() => {
            $('.product-proce').getProPrice({
              //cityCode:'025',
              isDefaultWork: true,
            })
          }, 200);
        })
      }
    },
    beforeRouteEnter(to, from, next) {

      let _this,
        urlParams = to.params,
        cityCode = urlParams.cityCode,
        storeCode = urlParams.storeCode;

      let iconReqPromise = Server.common.queryIconMenu(cityCode),//头部ICON菜单
        storeReqPromise = Server.Station.queryStationStore(storeCode),
        bannerReqPromise = Server.Station.queryStationBanner(cityCode),
        categoryReqPromise = Server.common.queryParameter('1044'),
        stationInfoPromise = Server.Station.queryStationInfo();


      Promise.all([iconReqPromise, storeReqPromise, bannerReqPromise, categoryReqPromise, stationInfoPromise])
        .then(([iconData, storeData, bannerData, categoryData, stationInfoData]) => {
          next(vm => {

            console.log(storeData);
            console.log('stationInfoDatastationInfoData', stationInfoData);
            if(!storeData.hasOwnProperty('storeInfo')){
            	return;
            }
            _this = vm;

            if (storeData.storeHeadPhotoList.length > 0) {
              _this.store.img = storeData.storeHeadPhotoList[0].imgUrl;
            } else {
              //_this.store.img = "//preres.suning.cn/project/cmsWeb/suning/o2o/wap/sidesun/static/images/sno2o_StoreType_zhiyingdian@2x.png";
              _this.store.img = '';
            }


            _this.store.info = stationInfoData;
            _this.store.name = storeData.storeInfo.name;
            _this.store.address = storeData.storeInfo.address;
            _this.store.tags = storeData.storeInfo.storeLabel.split(',');

            _this.store.weekDayTime = storeData.storeInfo.weekendBeginTime.substring(0, 5) + '-' + storeData.storeInfo.weekendEndTime.substring(0, 5);
            _this.store.workDayTime = storeData.storeInfo.workdayBeginTime.substring(0, 5) + '-' + storeData.storeInfo.workdayEndTime.substring(0, 5);
            if (storeData.storeInfo.telephone.split(';').length > 0) {
              _this.store.tel = storeData.storeInfo.telephone.split(';')[0];
            } else if (storeData.storeInfo.telephone.length > 0) {
              _this.store.tel = storeData.storeInfo.telephone;
            } else {
              _this.store.tel = '';
            }

            /*let activityDesc = '';
             _.forEach(storeData.storeActivityList, item => {
             activityDesc += '<span>' + item.title + '</span>';
             });*/
            _this.store.activityDesc = storeData.storeActivityList;

            console.log('storeData.storeActivityList', storeData.storeActivityList);


            if (storeData.guideInfo) {
              _this.person.name = storeData.guideInfo.guideName;
              _this.person.avatar = storeData.guideInfo.guidePhoto;
              _this.person.serverNum = storeData.guideInfo.orderNum;
              _this.person.info = storeData.guideInfo.introduction;
              _this.person.weeklyTopGuiderUrl = storeData.guideInfo.weeklyTopGuiderUrl;
            }


            _this.iconData = iconData.iconResponseNewList;
            _this.iconTipData = iconData.description.split('、');

            _this.banner = bannerData;

            console.log('bannerDatabannerData', bannerData);

            _this.navList = categoryData;

            _this.storeCode = storeCode;

          });
        });
    },
    methods: {
      //导航关注门店
      focusStore(){
        let _this = this,
          focus = _this.focus,
          params = {
            storeCode: _this.storeCode
          }


        $.probeAuthStatus(function () {

          //已登录执行方法
          if(focus.state === '0'){
            Server.storepage.addFocusStore(params).then(data => {
              if(data.code === '0'){
                focus.state = '1';
                AlertBox({
                  type: 'mini',
                  msg: '您已成功关注该门店，您下次可优先查看本店信息'
                })
              }else if(data.code === '0010'){
                AlertBox({
                  type: 'mini',
                  msg: data.msg
                })
              }
            })
          }else {
            AlertBox({
              type: 'doubleBtn',
              alertType: 'fixed',
              confirmText: '确定',
              cancelText: '再想想',
              msg: '您确定取消关注该门店',
              confirm: function () {
                Server.storepage.delFocusStore(params).then(data => {
                  if(data.code === '0'){
                    focus.state = '0';
                  }
                })
              },
              cancel: function () {

              }
            });
          }
          _this.focus = focus

        }, function () {
          //未登录执行
          Util.redirectToLogin();
        }, CONF.PASSPORT.CONFIG);

      },
      receiveHotNavData(e){

        this.catelogId = e.catalogueId
      },
      switchTab(type) {
        this.tab = type;

        if (type === 'info') {
          //this.catelogId = '';
        }
      },
      subscribe(url) {
        window.location.href = url;
      },
      //跳转商品参数页
      skipInfo(url,desc,sale){
        
        let storage = Util.getLocalStorage();
        storage.setItem('prdUrl',url);
        storage.setItem('prdDesc',desc);
        if(sale === ''){
          storage.setItem('prdSale', false);
        } else{
          storage.setItem('prdSale', sale);
        }
        
        storage.setItem('cityCode',this.$route.params.cityCode)
//        this.$router.push({
//          name: 'ProductInfo',
//          params: {
//            prdCode: code
//          }
//        });
      }
    }
  }
</script>
<style scoped>

  #station-page {
    box-sizing: border-box;
    background: #f2f2f2;
  }

  .nav{
    background: #ff9900;
  }
  .sn-nav-back{
    z-index: 9;
    margin: 0;
    border-bottom: 0;
    position: relative;
    height: 1.76rem;
    line-height: 1.76rem;
    font-size: 34px;
    width: 100%;
    a{
      height: 1.76rem;
    }
    .focus{
      /*border: 1px solid;*/
      position: absolute;
      background: url('../assets/focus.png') no-repeat center;
      background-size: 40px 40px;
      top: 24px;
      right: 30px;
      height: 40px;
      width: 40px;
    }
    .focus.act{
      background: url('../assets/focus_act.png') no-repeat center;
      background-size: 40px 40px;
    }
  }

  .title{
    font-family:PingFangSC-Medium;
    text-align: center;
    color:#ffffff;
  }

  .sn-nav-back:before{
    border: solid #fff;
    border-width: 3px 0 0 3px;
    -webkit-transform: rotate(-45deg);
    left: .56rem;
  }

  #store {
    background: #fff;
    padding: 20px;

  .store-l {
    margin-right: 20px;
    float: left;
    width: 160px;
    height: 160px;

  &.active {
     background: url("../assets/sno2o_StoreType_zhiyingdian@2x.png") 0 0 no-repeat;
     background-size: 160px 160px;
   }
  }
  .store-r {
    position: relative;
    overflow: hidden;

  &:after {
     display: none;
     content: '';
     width: 15px;
     height: 28px;
     background: url("../assets/arrow-icon.png") 0 0 no-repeat;
     background-size: 15px 28px;
     position: absolute;
     right: 0;
     top: 50%;
     margin-top: -14px;
   }

  h2 {
    font-family: "PingFangSC-Medium";
    font-size: 32px;
    color: #333333;
    margin-bottom: 10px;
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: "PingFangSC-Regular";
    font-size: 26px;
    color: #999999;
    display: block;
    text-indent: 25px;
    margin-bottom: 20px;
    position: relative;

  &:before {
     display: block;
     content: '';
     width: 18px;
     height: 24px;
     background: url("../assets/loca-icon.png") 0 0 no-repeat;
     background-size: 18px 24px;
     position: absolute;
     left: 0;
     top: 50%;
     margin-top: -12px;
   }
  }

  ul {
    font-family: "PingFangSC-Regular";
    font-size: 24px;
    color: #444444;

  li {
    border: 1px solid #ccc;
    float: left;
    border-radius: 2px;
    margin-right: 10px;
    padding: 0 5px;
  }
  }
  }
  }

  #station-content {
    margin-top: 20px;
    background: #ffffff;

  .station-tab {
    height: 78px;
    line-height: 78px;
    border-bottom: 1px solid #f8f8f8;
    font-family: "PingFangSC-Semibold";
    font-size: 30px;
    color: #000;
    text-align: center;
    display: -webkit-box;

  span {
    position: relative;
    display: block;
    -webkit-box-flex: 1;

  &.active {
     color: #FF9900;

  &:after {
     position: absolute;
     bottom: 0;
     left: 50%;
     margin-left: -30px;
     content: '';
     display: block;
     width: 60px;
     height: 4px;
     background: #FF9900;
   }
  }
  }
  }

  .hot-act {
    padding: 0 20px;
    height: 100px;
    line-height: 100px;
    border-bottom: 1px solid #f8f8f8;

  h2 {
    float: left;
    font-family: "PingFangSC-Medium";
    font-size: 34px;
    color: #222222;
    padding-right: 12px;
    position: relative;

  &:after {
     position: absolute;
     top: 50%;
     margin-top: -15px;
     right: 0;
     content: '';
     display: block;
     width: 2px;
     height: 30px;
     background: #f8f8f8;
   }
  }

  .marquee-box {
    top: 25px;
    overflow: hidden;
    height: 50px;
    position: relative;
    display: block;
    padding-left: 12px;
    font-family: "PingFangSC-Regular";
    font-size: 24px;
    color: #444444;

  #marquee-scroll {
    height: auto;
    position: absolute;
    left: 0;
    top: 0;
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    width: 100%;
    height: 50px;
    line-height: 50px;
  }
  }

  }
  }

  #enter-modules {
    background: #ffffff;
    height: 180px;
    padding: 25px;
    box-sizing: border-box;

  ul {
    width: 100%;
    height: 100%;
    display: -webkit-box;

  li {
    -webkit-box-flex: 1;
    width: 0;
    text-align: center;
    font-size:24px;
    color:#222222;
  img{
    border-radius: 50%;
    display: inline-block;
    width: 88px;
    height: 88px;
  }
  p{

    font-size:24px;
    color:#222222;
    line-height: 33px;
    margin: 8px 0 0 0;
  }
  }
  }
  }
  #tip-list {
    background: #f8f8f8;
    padding: 5px 0;
    box-sizing: border-box;

  ul {
    padding: 0 10px;
    width: 100%;
    overflow: hidden;
    height: auto;

  li {
    box-sizing: border-box;
    position: relative;
    margin: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    float: left;
    width: 126px;
    text-indent: 25px;
    font-family: "PingFangSC-Regular";
    font-size: 24px;
    color: #999999;

  &:before {
     background: url("../assets/serviceAssurance@2x.png") 0 0 no-repeat;
     position: absolute;
     top: 50%;
     margin-top: -10px;
     left: 0;
     content: '';
     display: block;
     width: 20px;
     height: 20px;
     background-size: 18px 18px;
     border-radius: 50%;
   }
  }
  }
  }

  #station-slide {
    width: 100%;
    height: 198px;
    overflow: hidden;
    z-index: 9;

  ul {
    margin: 0 auto;
    overflow: hidden;
    height: 100%;

  li {
    float: left;
    position: relative;
    height: 100%;

  img {
    display: block;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }
  }
  }
  }

  .store-intro {
    font-family: "PingFangSC-Regular";
    font-size: 24px;
    color: #444444;
    line-height: 40px;
    padding: 5px 20px;
    border-bottom: 1px solid #f8f8f8;
  }
  .store-td {
    box-sizing: border-box;
    /*text-indent: 30px;*/
    position: relative;
    height: 88px;
    line-height: 88px;
    border-bottom: 1px solid #f8f8f8;
    padding: 0 20px;
    padding-left: 50px;

  a {
    text-indent: 0;
    position: absolute;
    right: 20px;
    top: 50%;
    margin-top: -19px;
    height: 38px;
    line-height: 38px;
    padding: 0 10px;
    background: #FFAA00;
    border-radius: 2px;
    font-family: "PingFangSC-Regular";
    font-size: 26px;
    color: #FFFFFF;
  }

  &.tel {
  &:before {
     position: absolute;
     top: 50%;
     left: 20px;
     margin-top: -14px;
     content: '';
     display: block;
     background: url("../assets/tel.png") 0 0 no-repeat;
     width: 20px;
     height: 28px;
     background-size: 20px 28px;
   }
  }
  &.location {
  &:before {
     position: absolute;
     top: 50%;
     left: 20px;
     margin-top: -14px;
     content: '';
     display: block;
     background: url("../assets/loca-icon.png") 0 0 no-repeat;
     width: 28px;
     height: 28px;
     background-size: 20px 28px;
   }
  }
  &.hour {
  &:before {
     position: absolute;
     top: 50%;
     left: 20px;
     margin-top: -13px;
     content: '';
     display: block;
     background: url("../assets/sno2oStationShopHour@2x.png") 0 0 no-repeat;
     width: 25px;
     height: 25px;
     background-size: 25px 25px;
   }
  }
  }
  .work-time {

    padding-bottom: 10px;
    border-bottom: 1px solid #f8f8f8;

  .store-td {
    height: 50px;
    line-height: 50px;
    border: none;
  }

  .wtime {
    margin-bottom: 10px;
    text-indent: 50px;
  }
  }

  #store-person {

  .person-header {
  h3 {
    background: #FFAA00;
    line-height: 40px;
    text-align: center;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    height: 40px;
    width: 100px;
    font-family: "PingFangSC-Regular";
    font-size: 30px;
    color: #FFFFFF;
  }
  }
  .person-info {
    position: relative;
    padding: 10px 20px;

  .person-avatar {
    float: left;
    border-radius: 50%;
    overflow: hidden;
    width: 120px;
    height: 120px;
  }
  .info {
    overflow: hidden;

  h2 {
    margin-top: 10px;
    margin-bottom: 15px;
    font-family: "PingFangSC-Regular";
    font-size: 32px;
    color: #222222;

  span {
    margin-left: 15px;
    font-family: "PingFangSC-Regular";
    font-size: 24px;
    color: #999999;
  }
  }

  p {
    font-family: "PingFangSC-Regular";
    font-size: 28px;
    color: #666666;
  }
  }

  .p-subscribe {
    width: 130px;
    height: 50px;
    line-height: 50px;
    display: block;
    position: absolute;
    top: 50%;
    margin-top: -25px;
    right: 20px;
    background: #fff0d1;
    color: #e9b126;
    border: 1px solid #eacc86;
    text-align: center;

  }
  }
  }

  #station-fix-btn {
    box-shadow: 0 0 8px hsla(0, 0%, 0%, .3);
    width: 100%;
    height: 100px;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 89;
    display: -webkit-box;

  > div {
      width: 0;
      -webkit-box-flex: 1;
    }
  .subscribe {
    padding-left: 50px;
    background: #FFAA00;

  img {
    margin-top: 10px;
    display: block;
    overflow: hidden;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    float: left;
    margin-right: 25px;
  }

  h2 {
    padding-top: 5px;
    font-family: "PingFangSC-Medium";
    font-size: 30px;
    color: #FFFFFF;
  }

  span {
    font-family: "PingFangSC-Regular";
    font-size: 26px;
    color: #FFFFFF;
  }
  }

  .store-tel {
    background: #fff;
    position: relative;
  &:before {
     content: '';
     display: block;
     width: 36px;
     height: 36px;
     background: url("../assets/tel.png") 0 0 no-repeat;
     background-size: 36px 36px;
     position: absolute;
     left: 50%;
     top: 10px;
     margin-left: -18px;
   }

  a {
    display: block;
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 140px;
    font-family: "PingFangSC-Regular";
    font-size: 20px;
    color: #444444;
  }
  }

  }

  .hotSellList{
    background: #ffffff;
    padding: 45px 20px 0;
    margin: 0 0 1.5rem 0;
    li{
      margin: 0 0 40px 0;
      position: relative;
    }
    li:nth-child(1),li:nth-child(2),li:nth-child(3){
      .triangle_border_nw{
        border-color:transparent transparent transparent #fe001f;
      }
    }
    .horn{
      width: 60px;
      height: 60px;
      position: absolute;
      font-size:34px;
      color:#ffffff;
      letter-spacing:0;
      line-height: 40px;
      z-index: 1;
      text-indent: 5px;
    }
    .triangle_border_nw{
      width:0;
      height:0;
      border-width:0 0 60px 60px;
      border-style:solid;
      border-color:transparent transparent transparent #ffaa00;
      position:absolute;
    }
  }
  .sn-loading-type {
    padding-bottom: 100px;
  }
  .sn-end-loading span {
    position: relative;
    top: -35px;
  }
  .loadmore {
    height: 1px;
    display: block;
  }
</style>




// WEBPACK FOOTER //
// src/components/Station.vue